<div class="mapa-flotante">
  <app-flotante-luminarias
    [luminariasLength]="luminariasConUbicacion.length"
    [luminarias]="luminariasConUbicacion"
    [sinUbicacion]="sinUbicacion"
    [zonas]="zonas || []"
    (luminariaChange)="onLuminariaChange($event)"
    (clusterChange)="onClusterToggle($event)"
    (poligonoClientesChange)="onPoligonoClientesToggle($event)"
    (poligonoZonasChange)="onPoligonoZonasToggle($event)"
    (textoClientesChange)="onTextoClientesToggle($event)"
    (textoZonasChange)="onTextoZonasToggle($event)"
    (gatewayChange)="onGatewayToggle($event)"
    (clientesSeleccionadosChange)="onClienteSeleccionadoChange($event)"
    (accionPoligono)="onAccionPoligono($event)"
    [dona]="luminariasSeleccionadas.length ? dona : null"
  ></app-flotante-luminarias>
</div>

<!-- Dona del resumen: el panel la pone junto a los chips de Estados -->
<ng-template #dona>
  <app-pie-chart-luminarias
    class="mapa-dona"
    [data]="luminariasSeleccionadas"
    [chartStyle]="'width: 96px; height: 96px; display: block'"
  ></app-pie-chart-luminarias>
</ng-template>

<app-mapa-facil-v2
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaLuminariasComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
